var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListPage',{attrs:{"title":"Użytkownicy systemowi","data":_vm.data,"is-busy":_vm.isBusy,"filters":{},"table-params":[
              {label: '#', field: 'id', sortable: true, align:'right'},
              {label: 'Imię Nazwisko', field: 'name', sortable: true, align:'left'},
          ],"load-action-name":_vm.TYPES.SYSTEMUSERS_A_LOAD,"on-click-add":_vm.onClickAdd,"adding-permission-name":_vm.PRIVILEGES.PRIVILEGE_SYSTEMUSERS,"on-click-row":_vm.onClickRow}})
}
var staticRenderFns = []

export { render, staticRenderFns }